import React from 'react';
import { observer } from 'mobx-react-lite';
import cn from 'classnames';
import FloorPopup from '../FloorPopup/FloorPopup';
import { CustomFilterBodyProps } from '../customFilter.type';
import styles from './styles.module.scss';

const FloorAreaBody: React.FC<CustomFilterBodyProps> = observer(
  ({ childs, handleChange, category, item, ...props }) => (
    <FloorPopup
      onCancel={() => {
        item.onCancel(category, item);
      }}
      onSelect={() => {
        item.onConfirm(childs);
      }}
      isSingle={!!item.isSingle}
    >
      <div className={styles.FloorAreaBody} {...props}>
        {childs.map((item: any, i: number) => (
          <React.Fragment key={i}>
            <p
              onClick={
                () => {
                  const res = childs.map((child: any, index: number) => ({
                    ...child,
                    selected: index === i,
                  }));
                  item.onConfirm(res);
                }
                // () => handleChange && handleChange(item)
              }
              className={cn(styles.title, {
                [styles.selected]: item.selected,
              })}
            >
              {item?.title || ''}
              sqm
            </p>
          </React.Fragment>
        ))}
      </div>
    </FloorPopup>
  ),
);

export default FloorAreaBody;
